import { Tracking } from "./Tracking";
import { injectable } from "inversify";
import { ErrorReporter } from "@/infrastructure/ErrorReporter";
import { Action } from "@studyportals/datalake-event-tracker";
import { ITrackingData } from '@studyportals/datalake-event-tracker/dist/src/interfaces/tracking-data.interface';

@injectable()
export class LatencyTracking extends Tracking {

	public constructor(errorReporter: ErrorReporter) {
		super(errorReporter);
	}

	public track(time: number, variation: string): void {
		try {
			const trackingData: ITrackingData = {
				action: Action.TIME_SPENT,
				label: `search_api_response_time_${variation}`,
				property: 'organisation_search',
				value: time,
			};

			this.tracker.trackStructuredEvent(trackingData);
		} catch (error) {
			this.errorReporter.report(JSON.stringify(error));
		}
	}
}